export const LABEL_PREDEFINED_COLORS = [
	'#7057ff',
	'#008672',
	'#b60205',
	'#d93f0b',
	'#fbca04',
	'#0e8a16',
	'#1d76db',
	'#c5def5',
	'#f7e6cc',
	'#f9d0c4',
	'#fef2c0',
	'#bfe5bf',
	'#c2e0c6',
	'#bfd4f2',
	'#d4c5f9',
	'#e99695',
	'#2ecc40',
	'#000000',
];

export const LABEL_LIGHT_COLORS = [
	'#c5def5',
	'#f7e6cc',
	'#f9d0c4',
	'#fef2c0',
	'#bfe5bf',
	'#c2e0c6',
	'#bfd4f2',
	'#d4c5f9',
	'#e99695',
];

export const pickRandomLabelColor = (): string =>
	LABEL_LIGHT_COLORS[Math.floor(Math.random() * LABEL_LIGHT_COLORS.length)];

export const generateRandomColor = (): string => {
	const letters = '0123456789ABCDEF';
	let color = '#';
	for (let i = 0; i < 6; i++) {
		color += letters[Math.floor(Math.random() * 16)];
	}
	return color;
};

export const generateTempLabelId = (): number => -Date.now();
